import { crudMutations, crudActions } from './modules/action-helpers'

const basePath = 'api/work'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    currentItem: null
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...crudActions({ basePath: basePath }),
    async export ({ dispatch, state }, params) {
      return dispatch('export', { url: `${basePath}/report_worksheet`, params: params }, { root: true })
        .then(response => {
          return ''
        })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/works.js